import { type ReactElement } from 'react'
import { useRequiredParams } from '@util'
import { type CustomLocationId } from '@terros/common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Modal } from '@mantine/core'
import { CustomLocationDetail } from './CustomLocationDetail'

type CustomLocationParams = { customLocationId: CustomLocationId }

/** Rendered through the list's <Outlet />, so the list stays mounted behind the modal. */
function CustomLocationDetailModal(): ReactElement {
  const { customLocationId } = useRequiredParams<CustomLocationParams>()
  const navigate = useNavigate()
  const close = (): void => {
    navigate({ to: '/location/list' })
  }
  // Mantine closes every open modal on Escape; only close when nothing is stacked on top of this one
  const closeIfTopmost = (): void => {
    if (hasModalAbove()) return
    close()
  }

  return (
    <Modal
      opened
      onClose={closeIfTopmost}
      centered
      size='2xl'
      withCloseButton={false}
      styles={{ body: { padding: 0 } }}
      classNames={{ body: 'w-[80vw] max-w-[1440px] h-[90vh]', content: 'overflow-x-hidden' }}
    >
      <CustomLocationDetail customLocationId={customLocationId} onClose={close} />
    </Modal>
  )
}

/** True when another Mantine modal is open on top of this one. */
function hasModalAbove(): boolean {
  return document.querySelectorAll('.mantine-Modal-content').length > 1
}

export const Route = createFileRoute('/location/list/$customLocationId/')({
  component: CustomLocationDetailModal,
})
